// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  min-width: 600px;
}

@media print {
  .table {
    font-size: 11px;
  }

  .table td, .table th {
    padding: 2px !important;
  }
}


.text-small {
  /*font-size:88%;
  line-height:300%;*/
}

.negative-number {
  margin-right: -5px;
}

@media print {
  .negative-number {
    margin-right: -2px !important;
  }

  .card {
        box-shadow: none;
        margin-bottom: 0px;
    }
}


.wrap {
  white-space: normal;
}

.title-col {
  width: 611px;
  padding-left: 6px;
}

.title-col-sm {
  width: 300px;
  padding-left: 6px;
}

.amount-col {
  width: 165px;
  text-align: right;
}

.amount-col-lg {
  width: 185px;
  text-align: right;
}

.amount-col-sm {
  width: 100px;
  text-align: right;
}

.percent-col {
  width: 40px;
  text-align: right;
}

.py-2 {
  padding-top: 6px;
  padding-bottom: 6px;
}

.pr-2 {
  padding-right: 6px;
}

.pl-2 {
  padding-left: 6px;
}

.border-bottom {
  border-bottom: 1px solid #ccc;
}

.overflow-x-auto {
  overflow-x: auto;
}

@media print {
  .overflow-x-auto {
    overflow-x: visible;
  }

  .title-col {
    width: 200px;
    padding-left: 0px;
  }
}

.report-table {
  min-width: 600px;
}

.d-inline-block {
  display: inline-block;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
